export const EVENT_TOPICS = {
  SEND_USER: 'send-user',
  SEND_COURSE: 'send-course'
}
